import { render, staticRenderFns } from "./TerminalBlocks.vue?vue&type=template&id=5f5cfd18&scoped=true"
import script from "./TerminalBlocks.vue?vue&type=script&lang=js"
export * from "./TerminalBlocks.vue?vue&type=script&lang=js"
import style0 from "./TerminalBlocks.vue?vue&type=style&index=0&id=5f5cfd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5cfd18",
  null
  
)

export default component.exports